module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-plan-configuration"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "column row"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Rate configuration")])]), _c('div', {
    staticClass: "tabs-inner-content callout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column large-4"
  }, [_c('label', [_vm._v("Inherited reservation rate"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.inherited_reservation_rate_id),
      expression: "body.inherited_reservation_rate_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "inherited_reservation_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Not inherited")]), _vm._l((_vm.available), function(rate) {
    return _c('option', {
      domProps: {
        "value": rate.id
      }
    }, [_vm._v(_vm._s(rate.name))])
  })], 2)]), _c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [(_vm.loaded) ? _c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.translatable.description,
      "label": "Description"
    },
    model: {
      value: (_vm.body.description),
      callback: function($$v) {
        _vm.$set(_vm.body, "description", $$v)
      },
      expression: "body.description"
    }
  }) : _vm._e(), (_vm.loaded) ? _c('Editor', {
    model: {
      value: (_vm.body.description),
      callback: function($$v) {
        _vm.$set(_vm.body, "description", $$v)
      },
      expression: "body.description"
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Configuration")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.config),
      expression: "body.config"
    }],
    attrs: {
      "rows": "25"
    },
    domProps: {
      "value": (_vm.body.config)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "config", $event.target.value)
      }
    }
  })])]), _c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1800d7aa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/RateConfiguration.vue
// module id = 2290
// module chunks = 1